import { apiRequest } from "@/api/ApiRequest";
import { ApiMethod } from "@/types/Enums";
import type { LoginTypes } from "@/types/LoginTypes";
import type { MenuTypes } from "@/types/MenuTypes";

/**
 * Security API path
 * Format: /api/cmmn/~, /api/auth/~
 */

const _cmmnUrl = "/api/v1/cmmn";
const _authUrl = "/api/v1/auth";

/**
 * 로그인
 *
 * @remarks
 * - Admin 로그인
 * - #POST /api/v1/cmmn/login
 * @param data - 로그인정보
 */
export const postLogin = async (data: ParamsType): Promise<LoginTypes> => {
  return await apiRequest<LoginTypes>({
    method: ApiMethod.POST,
    headers: { "X-Requested-With": "XMLHttpRequest" },
    url: _cmmnUrl + "/login",
    data: data,
    useLoading: true,
  });
};

/**
 * 로그인 세션 확인
 *
 * @remarks
 * - 서버에서 로그인 세션 확인 후, 있으면 set
 * - #GET /api/v1/cmmn/verify-session
 */
export const verifySession = async (): Promise<LoginTypes> => {
  return await apiRequest<LoginTypes>({
    url: _cmmnUrl + "/verify-session",
  });
};

/**
 * 라우터 이동 권한체크
 *
 * @param params - URL정보
 * @remarks
 * - 서버에서 권한이동에 대한 권한 확인
 * - #GET /api/v1/auth/verify-router
 */
export const verifyRouter = async (params: ParamsType): Promise<string> => {
  return await apiRequest<string>({
    url: _authUrl + "/verify-router",
    params: params,
  });
};

/**
 * 로그아웃
 *
 * @remarks
 * - 서버에서 로그아웃 처리
 * - #GET /api/v1/cmmn/logout
 */
export const getLogout = async (): Promise<boolean> => {
  return await apiRequest<boolean>({
    url: _cmmnUrl + "/logout",
    useLoading: true,
    headers: { noAlert: "true" },
  });
};

/**
 * 유저(어드민) 라우트 목록 조회
 *
 * @remarks
 * - 관리자 라우트 목록 조회
 * - #GET /api/v1/auth/user-routes
 */
export const getUserMenuRoutes = async (): Promise<MenuTypes[]> => {
  return await apiRequest<MenuTypes[]>({
    url: _authUrl + "/user-routes",
  });
};

/**
 * 유저(일반사용자) 라우트 목록 조회
 *
 * @param div - 사용자 구분값
 * @remarks
 * - 일반사용자 라우트 목록 조회
 * - #GET /api/v1/cmmn/user-routes
 */
export const getCmmnUserMenuRoutes = async (div?: string): Promise<MenuTypes[]> => {
  return await apiRequest<MenuTypes[]>({
    url: _cmmnUrl + "/user-routes",
    params: div ? { div } : {},
  });
};
